// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".note-comment{margin-bottom:12px}.note-comment .note-comment__body{border-radius:28px;padding:8px 18px;flex:0 1 auto}.note-comment .theme--light .note-comment__body{background:#f5f5f5}.note-comment .theme--dark .note-comment__body{background:#292929}.note-comment .note-comment__details{display:flex;margin-left:82px}", ""]);
// Exports
module.exports = exports;
